import { environment } from "src/environments/environment";
import { ContactData } from "./ContactData.interface";

export const INITIAL_CONTACT_DATA: ContactData = (environment.mock && environment.mockContactData) ? {
    title: "Herr",
    firstName: "Han",
    lastName: "Solo",
    birthDate: new Date("1977-05-25"),
    phoneNumber: "06831 1234",
    mobileNumber: "0170 123 456",
    email: "han@solo",
    emailConfirmation: "han@solo",
    promoCustomerNumber: ""
  } : {
    title: "",
    firstName: "",
    lastName: "",
    birthDate: null,
    phoneNumber: "",
    mobileNumber: "",
    email: "",
    emailConfirmation: "",
    promoCustomerNumber: ""
  }
  